<div style="background-color: var(--primary); color: white" *ngIf="user">
  <div class="p-2">
    <div class="d-flex justify-content-between">
      <div style="width: -webkit-fill-available">
        <h4 class="mb-0">{{ "topbar.profile.user" | translate }}</h4>
      </div>
      <h3 class="m-0 c-pointer" (click)="globalFunction.Modal('template','hide')">&times;</h3>
    </div>

    <div class="center flex-column text-center">
      <img
        [src]="validateImageOrganization(user)"
        style="height: 100px; width: 100px"
        class="rounded-circle"
        alt="logo"
        onerror="this.onerror=null;this.src='assets/img/dummy.png';"
      />
      <div class="d-flex flex-column gap-5 mt-2">
        <h4>
          {{ user.client && user.client.organization ? user.client.organization.business_name : "No
          tiene datos activos" }}
        </h4>
        <h4>
          {{ user.client && user.client.organization ? user.client.organization.name : "No tiene
          datos activos" }}
        </h4>
      </div>
    </div>
  </div>
  <div class="content-profile">
    <div class="row" *ngIf="!edit">
      <!-- Datos del usuario -->
      <div class="col-12 col-md-6 center mb-3 mb-md-0">
        <div class="content-image">
          <div class="position-relative">
            <img
              [src]="validateImage(user)"
              style="height: 100px; width: 100px"
              class="rounded-circle"
              alt="logo"
              onerror="this.onerror=null;this.src='assets/img/dummy.png';"
            />
            <i
              class="fa fa-edit c-pointer text-success profile-edit"
              [title]="'general.edit' | translate"
              (click)="edit = true"
            ></i>
          </div>
          <div class="d-flex flex-column mt-2">
            <small>
              {{ user.first_name && user.last_name ? user.first_name + ' ' + user.last_name :
              user.username }}
            </small>
            <small>{{ user.email }}</small>
          </div>
        </div>
      </div>

      <!-- Grupos -->
      <div class="col-12 col-md-6">
        <div class="profile-info-card">
          <!-- Plan, historial de pagos y tarjetas ocultos: el cliente aun no debe ver nada de suscripciones
          <h6 class="font-weight-bold mb-1">{{ "topbar.profile.plan" | translate }}</h6>
          <ng-container *ngIf="user.subscription; else noPlanTpl">
            <div class="d-flex align-items-center gap-10">
              <small>{{ user.subscription.product?.name }}</small>
              <span
                class="plan-status"
                [ngClass]="getPlanStatusClass()"
                [title]="getPlanStatusKey() | translate"
              ></span>
            </div>
            <small class="d-block" *ngIf="user.subscription.price">
              $ {{ user.subscription.price.price_with_decimals | number: "1.2-2" }} /
              {{ getPlanIntervalKey() | translate }}
            </small>
            <small class="d-block" *ngIf="user.subscription.period_end">
              {{ getPlanPeriodKey() | translate }}
              {{ user.subscription.period_end | date: "dd/MM/yyyy" }}
            </small>
          </ng-container>
          <ng-template #noPlanTpl>
            <small class="d-block">{{ "topbar.profile.no-plan" | translate }}</small>
          </ng-template>

          <div class="d-flex flex-wrap gap-10 mt-2" *ngIf="!user.is_subclient">
            <button type="button" class="btn btn-primary btn-sm" (click)="goToPaymentHistory()">
              <i class="fa fa-history mr-1"></i>
              {{ "topbar.profile.payment-history" | translate }}
            </button>
            <button
              type="button"
              class="btn btn-outline-primary btn-sm"
              (click)="goToPaymentMethods()"
            >
              <i class="fa fa-credit-card mr-1"></i>
              {{ "topbar.profile.payment-methods" | translate }}
            </button>
          </div>
          -->
          <div class="profile-groups-header">
            <i class="fa fa-users" aria-hidden="true"></i>
            <h6 class="font-weight-bold m-0">{{ "topbar.profile.groups" | translate }}</h6>
            <i class="profile-groups-count" *ngIf="groups.length > 0">{{ groups.length }}</i>
          </div>
          <div class="profile-groups-list" *ngIf="groups.length > 0; else noGroupsTpl">
            <span class="profile-group-chip" *ngFor="let group of groups" [title]="group.name">
              {{ group.name }}
            </span>
          </div>
          <ng-template #noGroupsTpl>
            <small class="d-block">{{ "topbar.profile.no-groups" | translate }}</small>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="edit">
      <div class="col-12">
        <div class="mt-2">
          <app-imageCropper [url]="logo" [colorText]="'#656565'" (setbase64)="getbase64($event)">
          </app-imageCropper>
          <span class="text-danger" *ngIf="!logo">{{ "admin.organization.image-required" | translate }}</span>
        </div>
        <form [formGroup]="userForm" (submit)="submitForm()">
          <div>
            <span>{{ "tables.name" | translate }}</span>
            <input type="text" class="form-control" formControlName="first_name" />
          </div>
          <div>
            <span>{{ "tables.last-name" | translate }}</span>
            <input type="text" class="form-control" formControlName="last_name" />
          </div>
          <div>
            <span>{{ "footer.email" | translate }}</span>
            <input type="email" class="form-control" formControlName="email" />
          </div>
          <div class="text-center w-100">
            <button type="button" class="btn btn-link text-muted mt-3" (click)="edit = false">
              {{ "topbar.profile.cancel-edit" | translate }}
            </button>
            <button class="btn btn-primary mt-3" [disabled]="userForm.invalid">
              {{ "admin.organization.save-info" | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
